var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":""}},[_c('vbt-search',{attrs:{"items":_vm.searchFieldsConfig},on:{"reset":_vm.onResetSearch,"search":_vm.onSearch},model:{value:(_vm.searchData),callback:function ($$v) {_vm.searchData=$$v},expression:"searchData"}}),_c('vbt-content-box',{attrs:{"loading":_vm.isLoading,"loading-error":_vm.loadingError,"no-content":_vm.noContent,"go-back-btn":_vm.goBack,"title":"Information"}},[_c('vbt-table',{attrs:{"items":_vm.pressSheets,"headers":_vm.headers,"show-details-action":""},on:{"click:details":function (ref) {
      var id = ref.outerId;

      return _vm.$router.push({
        name: 'pressSheet',
        params: { id: id },
        query: { suffix: _vm.suffix },
      });
}},scopedSlots:_vm._u([{key:"id",fn:function(ref){
      var id = ref.item.outerId;
return [_c('router-link',{staticClass:"info--text",attrs:{"to":{
            name: 'pressSheet',
            params: { id: id },
            query: { suffix: _vm.suffix },
          }}},[_vm._v(" "+_vm._s(id)+" ")])]}},{key:"status",fn:function(ref){
          var status = ref.item.status;
return [_c('kernel-status-badge',{attrs:{"status":_vm.pressSheetStatusEnumByValue[status]}},[_vm._v(" "+_vm._s(status)+" ")])]}},{key:"uv",fn:function(ref){
          var ref_item = ref.item;
          var uvFront = ref_item.uvFront;
          var uvBack = ref_item.uvBack;
return [_c('v-layout',{attrs:{"column":""}},[_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(uvFront),expression:"uvFront"}]},[_vm._v(" Front: "+_vm._s(uvFront)+" ")]),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(uvBack),expression:"uvBack"}]},[_vm._v(" Back: "+_vm._s(uvBack)+" ")])],1)]}},{key:"expires",fn:function(ref){
          var expires = ref.item.expires;
return [_vm._v(" "+_vm._s(_vm.formatDate(expires))+" ")]}}])}),_c('vbt-pagination',{attrs:{"items-count":_vm.pagedItemsCount},model:{value:(_vm.pageNum),callback:function ($$v) {_vm.pageNum=$$v},expression:"pageNum"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }